export enum DownloadTypeEnum {
  PDF = 'PDF',
  EXCEL = 'EXCEL',
}